import { defineMessage, MessageDescriptor } from 'react-intl'

import { SeasonEnum } from '../../../../../../../../../lib/graphql'

export const getSeasonLabel = (season: SeasonEnum): MessageDescriptor => {
  switch (season) {
    case SeasonEnum.LOW:
      return defineMessage({
        id: 'ui.getSeasonLabel.low',
        defaultMessage: 'Basse saison',
      })
    case SeasonEnum.MEDIUM:
      return defineMessage({
        id: 'ui.getSeasonLabel.medium',
        defaultMessage: 'Moy. saison',
      })
    case SeasonEnum.HIGH:
      return defineMessage({
        id: 'ui.getSeasonLabel.high',
        defaultMessage: 'Haute saison',
      })
  }
}
